import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { getDiscountPrice, productApi } from "../../../helpers/product";

const MenuCart = ({ cartData, currency, deleteFromCart, cartModal, onClickOutsideListener }) => {
  let cartTotalPrice = 0;
  const { addToast } = useToasts();
  const calculateTotal = (totalCartPrice) => {
    let sum = 0
    for (let i = 0; i < totalCartPrice?.length; i += 1) {
      sum += totalCartPrice[i].discountedFee > 0 ? totalCartPrice[i].discountedPrice : totalCartPrice[i].totalPrice
    }
    return sum.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  };

  const calculateQty = (qtyData) => {
    let sum = qtyData?.reduce(function(prev, current) {
      return prev + +current.quantity
    }, 0);
    return sum
  }
  return (
    <div className="shopping-cart-content" ref={cartModal}>
      {cartData && cartData.length > 0 ? (
        <Fragment>
          <ul>
            {cartData.map((single, key) => {
              const discountedPrice = getDiscountPrice(
                single.price,
                single.discount
              );
              const finalProductPrice = (
                single.price * currency.currencyRate
              ).toFixed(2);
              const finalDiscountedPrice = (
                discountedPrice * currency.currencyRate
              ).toFixed(2);

              discountedPrice != null
                ? (cartTotalPrice += finalDiscountedPrice * single.quantity)
                : (cartTotalPrice += finalProductPrice * single.quantity);

              return (
                <li className="single-shopping-cart" key={key}>
                  <div className="shopping-cart-img">
                    <Link to={process.env.PUBLIC_URL + "/product/" + single?.slugid}>
                      <img
                        alt=""
                        src={single.primaryImage}
                        className="img-fluid"
                      />
                    </Link>
                  </div>
                  <div className="shopping-cart-title">
                    <h4>
                      <Link
                        to={process.env.PUBLIC_URL + "/product/" + single?.slugid}
                      >
                        {" "}
                        Product ID: {single.productId}{" "}
                      </Link>
                    </h4>
                    <span>Qty: {calculateQty(single.sizes)}</span>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '7px'}}>
                    {/* <span>${single?.totalPrice?.toFixed(2)}</span> */}
                    </div>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '7px'}}>
                    <span>Color: {single.color}</span>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '7px'}}>
                    <span>Sizes:{' '}
                    {single.sizes.map((items, index) => {
                      return(
                        <span key={index}>
                         {items.size}({items.quantity}), </span>)
                    })}
                    </span>

                    </div>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '7px'}}>
                    <span>Decoration: {single?.decorationType?.toLowerCase() === 'screenprint' ? 'Screenprint' : single?.decorationType}</span>
                    </div>
                    {single.decorations?.map((location, index) => {
                      return (
                        <div key={index} style={{display: 'flex', justifyContent: 'space-between'}}>
                          <span>Location {index + 1}: {location.location}</span>
                        </div>
                      )
                    })
                    }
                    
                    
                    {/* <span>
                      {discountedPrice !== null
                        ? currency.currencySymbol + finalDiscountedPrice
                        : currency.currencySymbol + finalProductPrice}
                    </span> */}
                  </div>
                  <div className="shopping-cart-delete">
                    {/* <button onClick={() => {
                      deleteFromCart(single, addToast)
                      sessionStorage.removeItem('coupon')
                      }}>
                      <i className="fa fa-times-circle" />
                    </button> */}
                  </div>
                </li>
              );
            })}
          </ul>
          <div className="shopping-cart-total">
            <h4>
              Total :{" "}
              <span className="shop-total">
                <b>${calculateTotal(cartData)}</b>
              </span>
            </h4>
          </div>
          <div className="shopping-cart-btn btn-hover text-center">
            <Link className="default-btn" to={process.env.PUBLIC_URL + "/cart"}>
              view cart
            </Link>
          </div>
        </Fragment>
      ) : (
        <p className="text-center">No items added to cart</p>
      )}
    </div>
  );
};

MenuCart.propTypes = {
  cartData: PropTypes.array,
  currency: PropTypes.object,
  deleteFromCart: PropTypes.func
};

export default MenuCart;
